import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { MeterConfigurationData } from "../../../ThirdPartySystems.types";

function getWattlineColumns(): Array<MRT_ColumnDef<MeterConfigurationData>> {
  return [
    { header: "Seriennummer", accessorKey: "parameters.serialNumber" },
    {
      header: "Richtung der Messung",
      accessorKey: "parameters.meteringDirection"
    }
  ];
}

export { getWattlineColumns };
